<template>
  <div class="scanning-for-pickup">
    <div class="head" v-if="tableList.length">已扫描</div>
    <div class="content" v-if="tableList.length">
      <div class="item" v-for="(item, i) in tableList" :key="i">
        <span class="title">快递单号</span>
        <span>{{ item.orderNum }}</span>
      </div>
    </div>
    <div class="lb" v-else>
      <img src="../assets/img/express.jpg" />
      <div class="text">
        步骤如下
        <br />
        1. 个人中心绑定个人信息
        <br />
        <br />
        2. 自主取件扫描面单条形码
        <br />
        <br />
        3. 如果有多个继续扫描
        <br />
        <br />
        4. 上传成功后扫描闸机出去
        <br />
      </div>
    </div>
    <div class="buts">
      <van-button round type="primary" @click="scan('barCode')" size="large"
        >扫描包裹</van-button
      >
      <van-button
        round
        type="primary"
        v-if="tableList.length"
        @click="scan('qrCode')"
        size="large"
        >扫描闸门</van-button
      >
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import wx from "weixin-js-sdk";
import * as http from "@/api/index.js";
export default {
  name: "ScanningForPickup",
  data() {
    return {
      tableList: [],
    };
  },
  created() {
    document.title = "快递代取";
    http.login();
  },
  methods: {
    // 扫描
    async scan(scanType) {
      const { appId } = JSON.parse(localStorage.getItem("tokenVo"));
      const { data: wxConfig } = await http.getWxConfig(appId);
      wx.config({
        debug: false,
        appId: appId,
        timestamp: wxConfig.timeStamp,
        nonceStr: wxConfig.nonceStr,
        signature: wxConfig.signature,
        jsApiList: ["scanQRCode"],
      });
      wx.ready(() => {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果
          scanType: [scanType],
          success: (res) => {
            this.scanSuccess(scanType, res.resultStr);
          },
        });
      });
      wx.error(function (res) {
        console.error(res);
      });
    },

    // 扫描成功
    async scanSuccess(scanType, resultStr) {
      if (scanType === "barCode") {
        const orderNum = resultStr.split(",")[1];

        // 重复单号
        if (
          this.tableList.some((item) => {
            return item.orderNum === orderNum;
          })
        ) {
          Dialog.confirm({
            title: "提示",
            message: `重复单号\n请扫描另一个快递`,
            confirmButtonText: "扫描闸机出去",
            cancelButtonText: "继续扫描",
          })
            .then(() => {
              this.scan("qrCode");
            })
            .catch(() => {
              this.scan("barCode");
            });
          return;
        }

        const { data } = await http.orderOutSaveBatch([{ orderNum }]);
        this.tableList.unshift(data[0]);
        Dialog.confirm({
          title: "提示",
          message: `单号：${orderNum}\n该包裹已经扫描成功\n多个包裹请继续扫描`,
          confirmButtonText: "扫描闸机出去",
          cancelButtonText: "继续扫描",
        })
          .then(() => {
            this.scan("qrCode");
          })
          .catch(() => {
            this.scan("barCode");
          });
      }
      if (scanType === "qrCode") {
        await http.orderOutUpdateBatch(
          this.tableList.map((i) => ({
            ...i,
            gateCode: resultStr,
          }))
        );
        await http.security(resultStr);
        Toast.success("开门成功");
        wx.closeWindow();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.scanning-for-pickup {
  height: 100%;
  background-color: #f4f1f2;

  .head {
    height: 40px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #333;
    font-weight: 600;
    border-bottom: 1px solid #eee;
    box-shadow: 0 0 10px #ccc;
    margin-bottom: 10px;
  }

  .content {
    height: calc(100% - 90px - 40px);
    overflow-y: scroll;
    padding: 10px;

    .item {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      background-color: #fff;
      margin-bottom: 10px;

      .title {
        color: #999;
      }

      span {
        color: #333;
      }
    }
  }

  .lb {
    padding: 10px;
    height: calc(100% - 90px);

    img {
      width: 100%;
      height: 240px;
    }

    .text {
      font-size: 14px;
      color: #999;
      padding: 10px;
      line-height: 25px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      box-shadow: 0 0 10px #ccc;
    }
  }

  .buts {
    display: flex;
    padding: 10px 40px;
    height: 90px;

    .van-button + .van-button {
      margin-left: 10px;
    }
  }
}
</style>